<div class="container-fluid px-2 px-md-3 px-xl-1 py-3">
  <div class="d-flex flex-column gap-3">
    <section class="entity-config-top rounded-4 overflow-hidden border-0">
      <div class="entity-config-top-hero px-2 px-md-2 py-2">
        <div class="row g-2 align-items-start flex-nowrap p-2">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Service Level Agreements</h1>
            <p class="entity-page-subtitle text-white mb-0 subsystem-subtitle">
              Create and manage SLA targets, warning windows, and escalation rules from one place.
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark text-xs d-inline-flex align-items-center rounded-3 px-3 py-2 shadow-sm me-2 align-self-end"
              data-bs-toggle="modal"
              data-bs-target="#create_sla_modal"
              @click="open_create_modal"
            >
              <i class="bi bi-plus-circle-fill me-2 text-white"></i>
              Create SLA
            </button>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-3 pb-3">
        <section class="row g-2 entity-config-top-metrics">
          <div v-for="metric in metrics" :key="metric.label" class="col-12 col-md-6 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">{{ metric.label }}</span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ metric.value }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i :class="metric.icon"></i>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    <section class="entity-inventory-panel rounded-4 border shadow-sm p-2">
      <div class="row g-2 align-items-start align-items-lg-center mb-3">
        <div class="col-12 col-lg">
          <div class="d-flex align-items-center gap-3">
            <div class="entity-section-icon rounded-3 d-inline-flex align-items-center justify-content-center">
              <i class="bi bi-grid-3x3-gap-fill"></i>
            </div>
            <div>
              <div class="entity-section-title fw-bold fs-6">Active SLAs</div>
              <div class="text-secondary text-xxs">Showing configured SLA policies pulled from the backend API.</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-auto">
          <div class="d-grid d-sm-flex align-items-stretch gap-2">
            <div class="input-group d-none d-md-flex">
              <span class="input-group-text bg-light border-0 rounded-start-pill">
                <i class="bi bi-search text-secondary"></i>
              </span>
              <input
                v-model.trim="search_query"
                type="text"
                class="form-control form-control-sm bg-light border-0 rounded-end-pill text-x"
                placeholder="Search SLA..."
              />
            </div>

            <button
              type="button"
              class="btn btn-light btn-sm rounded-3"
              :class="filter_mode !== 'all' ? 'border-primary text-primary' : ''"
              :title="`Filter: ${filter_mode}`"
              @click="toggle_filter_mode"
            >
              <i class="bi bi-funnel"></i>
            </button>

            <button
              type="button"
              class="btn btn-light btn-sm rounded-3"
              :title="`Sort: ${sort_label()}`"
              @click="cycle_sort_mode"
            >
              <i class="bi bi-sliders"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="d-md-none mb-3">
        <div class="input-group">
          <span class="input-group-text bg-light border-0 rounded-start-pill">
            <i class="bi bi-search text-secondary"></i>
          </span>
          <input
            v-model.trim="search_query"
            type="text"
            class="form-control form-control-sm bg-light border-0 rounded-end-pill"
            placeholder="Search SLA..."
          />
        </div>
      </div>

      <div class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide">
        <div class="row g-2 align-items-center">
          <div class="col-lg-3">SLA Name</div>
          <div class="col-lg-2">Target Duration</div>
          <div class="col-lg-2">Warning Threshold</div>
          <div class="col-lg-2">Escalation Duration</div>
          <div class="col-lg-1">Date Created</div>
          <div class="col-lg-1 text-end">Actions</div>
        </div>
      </div>

      <div v-if="loading" class="d-flex align-items-center gap-2 text-secondary text-xs py-2">
        <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
        <span>Loading SLA configs...</span>
      </div>

      <div v-else-if="paginated_slas.length" class="d-flex flex-column gap-2">
        <article
          v-for="sla in paginated_slas"
          :key="sla.id"
          class="entity-row-card bg-white rounded-4 border shadow-sm p-3"
        >
          <div class="entity-row-layout row g-2 align-items-center">
            <div class="entity-name-block col-12 col-lg-3 d-flex align-items-start align-items-sm-center gap-3">
              <div class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center">
                <i class="bi bi-alarm text-white fs-5"></i>
              </div>
              <div>
                <div class="entity-name fw-bold">{{ sla.name }}</div>
                <div class="entity-updated text-secondary small">{{ sla.description || 'No description provided for this SLA.' }}</div>
               
              </div>
            </div>

            <div class="col-12 col-sm-6 col-lg-2">
              <div class="sla-cell-label text-uppercase text-xxs fw-bold text-secondary d-lg-none mb-1">Target Duration</div>
              <span class="text-xs fw-semibold text-secondary">{{ sla.target_duration_label }}</span>
            </div>

            <div class="col-12 col-sm-6 col-lg-2">
              <div class="sla-cell-label text-uppercase text-xxs fw-bold text-secondary d-lg-none mb-1">Warning Threshold</div>
              <span class="text-xs fw-semibold text-secondary">{{ sla.warning_threshold_label }}</span>
            </div>

            <div class="col-12 col-sm-6 col-lg-2">
              <div class="sla-cell-label text-uppercase text-xxs fw-bold text-secondary d-lg-none mb-1">Escalation Duration</div>
              <span class="text-xs fw-semibold text-secondary">{{ sla.escalation_duration_label }}</span>
            </div>

            <div class="col-12 col-lg-2">
              <div class="sla-cell-label text-uppercase text-xxs fw-bold text-secondary d-lg-none mb-1">Date Created</div>
              <span class="text-xs text-secondary">{{ sla.created_label }}</span>
            </div>

            <div class="col-12 col-lg-1 d-flex justify-content-lg-end">
              <div class="sla-cell-label text-uppercase text-xxs fw-bold text-secondary d-lg-none mb-1">Actions</div>
              <div class="d-flex align-items-center gap-2">
                <button
                  type="button"
                  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                  data-bs-toggle="modal"
                  data-bs-target="#workflow_assignment_modal"
                  @click="open_workflow_modal(sla)"
                >
                  Assign 
                </button>
                <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1" @click="go_to_manage_sla(sla)">
                  Manage
                </button>
                <button
                  type="button"
                  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                  data-bs-toggle="modal"
                  data-bs-target="#update_sla_modal"
                  @click="open_update_modal(sla)"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </article>
      </div>

      <div v-else class="bg-white rounded-4 border shadow-sm p-5 text-center">
        <div class="entity-type-icon entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center mb-3">
          <i class="bi bi-bell fs-3"></i>
        </div>
        <div class="fw-bold mb-1">No SLA configs found</div>
        <div class="text-secondary small">Create your first SLA to start enforcing timing and escalation rules.</div>
      </div>

      <div
        v-if="!loading && paginated_slas.length"
        class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2 px-2 py-3"
      >
        <div class="text-secondary text-xs">{{ pagination_label }}</div>

        <nav aria-label="SLA pagination">
          <div class="d-inline-flex align-items-center rounded-3 border overflow-hidden bg-white">
            <button
              type="button"
              class="btn btn-sm btn-light border-0 rounded-0 px-2"
              @click="set_page(current_page - 1)"
              :disabled="current_page === 1"
              aria-label="Previous page"
            >
              <i class="bi bi-chevron-left"></i>
            </button>

            <button
              v-for="page in total_pages"
              :key="page"
              type="button"
              class="btn btn-sm rounded-0 border-0 border-start px-3 pagination-seg-btn"
              :class="page === current_page ? 'btn-primary-dark text-white' : 'btn-light'"
              @click="set_page(page)"
            >
              {{ page }}
            </button>

            <button
              type="button"
              class="btn btn-sm btn-light border-0 border-start rounded-0 px-2"
              @click="set_page(current_page + 1)"
              :disabled="current_page === total_pages"
              aria-label="Next page"
            >
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </nav>
      </div>
    </section>
  </div>
</div>

<teleport to="body">
  <div class="modal fade" id="create_sla_modal" tabindex="-1" aria-labelledby="create_sla_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <div>
            <p class="modal-title text-white text-xs mb-0" id="create_sla_modal_label">{{ create_form.id ? 'Update SLA' : 'Create SLA' }}</p>
            <p class="text-white-50 text-xxs mb-0">Define the target window, warning threshold, and escalation timing.</p>
          </div>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <form @submit.prevent="create_sla_config">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <label class="modal-form-label text-xs" for="sla_name">SLA Name</label>
                <input id="sla_name" v-model.trim="create_form.name" type="text" class="form-control modal-form-control text-xs" placeholder="Supplier Document Review SLA" />
              </div>
              <div class="col-12 col-md-6">
                <label class="modal-form-label text-xs" for="sla_target_duration">Target Duration</label>
                <input id="sla_target_duration" v-model.trim="create_form.target_duration" type="text" class="form-control modal-form-control text-xs" placeholder="2 days" />
              </div>
              <div class="col-12">
                <label class="modal-form-label text-xs" for="sla_description">Description</label>
                <textarea id="sla_description" v-model.trim="create_form.description" rows="3" class="form-control modal-form-control text-xs" placeholder="Review supplier documents within 48 hours"></textarea>
              </div>
              <div class="col-12 col-md-4">
                <label class="modal-form-label text-xs" for="sla_warning_threshold">Warning Threshold</label>
                <input id="sla_warning_threshold" v-model.trim="create_form.warning_threshold" type="text" class="form-control modal-form-control text-xs" placeholder="1 day 12 hours" />
              </div>
              <div class="col-12 col-md-4">
                <label class="modal-form-label text-xs" for="sla_escalation_duration">Escalation Duration</label>
                <input id="sla_escalation_duration" v-model.trim="create_form.escalation_duration" type="text" class="form-control modal-form-control text-xs" placeholder="3 days" />
              </div>
              <div class="col-12 col-md-4 d-flex align-items-end">
                <label class="modal-form-label text-xs w-100 mb-0">
                  <span class="d-block mb-2">Active</span>
                  <span class="d-flex align-items-center justify-content-between rounded-3 border bg-light px-3 py-2">
                    <span class="text-secondary text-xs ms-2">Enable this SLA</span>
                    <input v-model="create_form.is_active" class="form-check-input pm-purple-check ms-2" type="checkbox">
                  </span>
                </label>
              </div>
            </div>

            <div class="mt-3 text-secondary text-xxs">You can type durations like `2 days`, `1 day 12 hours`, or `48 hours`. The app will convert them for the backend.</div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end gap-2">
            <button type="submit"  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" :disabled="saving">
              <span v-if="saving" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ saving ? 'Creating...' : 'Create SLA' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="workflow_assignment_modal" tabindex="-1" aria-labelledby="workflow_assignment_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-4 p-0 shadow-lg overflow-hidden">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <div>
            <p class="modal-title text-white text-xs mb-0" id="workflow_assignment_modal_label">Manage Workflow</p>
            <p class="text-white-50 text-xxs mb-0">Assign or unassign the workflow linked to this SLA.</p>
          </div>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close" @click="close_workflow_modal"></button>
        </div>

        <div class="modal-body p-3 p-md-4">
          <div class="rounded-4 border bg-white shadow-sm p-3">
            <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
              <div>
                <div class="fw-bold text-xs">Workflow assignment</div>
                <div class="text-secondary text-xxs">
                  Select one workflow for this SLA. Status triggers will use that workflow's statuses only.
                </div>
              </div>
              <span class="badge rounded-pill text-uppercase text-xxs" :class="workflow_form.current_workflow_id ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'">
                {{ workflow_form.current_workflow_id ? 'Assigned' : 'Unassigned' }}
              </span>
            </div>

            <div class="row g-3">
              <div class="col-12">
                <label class="modal-form-label text-xs" for="workflow_assignment_select">Select Workflow</label>
                <select id="workflow_assignment_select" v-model="workflow_form.workflow_id" class="form-select modal-form-control text-xs">
                  <option value="">No workflow assigned</option>
                  <option v-for="workflow in workflow_options" :key="workflow.id" :value="String(workflow.id)">
                    {{ workflow.name }}
                  </option>
                </select>
              </div>

              <div class="col-12">
                <div v-if="workflow_form.current_workflow_name" class="alert alert-light border mb-0 py-2 text-xs text-secondary rounded-3">
                  Current workflow: <span class="fw-semibold">{{ workflow_form.current_workflow_name }}</span>
                </div>
                <div v-else class="alert alert-light border mb-0 py-2 text-xs text-secondary rounded-3">
                  This SLA is not bound to any workflow yet.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer border-0 p-3 d-flex justify-content-end gap-2 bg-body-tertiary">
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm rounded-small px-3"
            :disabled="workflow_saving"
            data-bs-dismiss="modal"
            @click="close_workflow_modal"
          >
            Close
          </button>
          <button
            v-if="workflow_form.current_workflow_id"
            type="button"
            class="btn btn-outline-danger btn-sm rounded-small px-3"
            :disabled="workflow_saving"
            @click="unassign_workflow_from_sla"
          >
            <span v-if="workflow_saving" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Unassign
          </button>
          <button
            type="button"
           class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
            :disabled="workflow_saving || !workflow_form.workflow_id"
            @click="save_workflow_assignment"
          >
            <span v-if="workflow_saving" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{ workflow_saving ? 'Saving...' : 'Assign Workflow' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="update_sla_modal" tabindex="-1" aria-labelledby="update_sla_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <div>
            <p class="modal-title text-white text-xs mb-0" id="update_sla_modal_label">Update SLA</p>
            <p class="text-white-50 text-xxs mb-0">Edit the target window, warning threshold, and escalation timing.</p>
          </div>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <form @submit.prevent="update_sla_config">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <label class="modal-form-label text-xs" for="update_sla_name">SLA Name</label>
                <input id="update_sla_name" v-model.trim="create_form.name" type="text" class="form-control modal-form-control text-xs" placeholder="Supplier Document Review SLA" />
              </div>
              <div class="col-12 col-md-6">
                <label class="modal-form-label text-xs" for="update_sla_target_duration">Target Duration</label>
                <input id="update_sla_target_duration" v-model.trim="create_form.target_duration" type="text" class="form-control modal-form-control text-xs" placeholder="2 days" />
              </div>
              <div class="col-12">
                <label class="modal-form-label text-xs" for="update_sla_description">Description</label>
                <textarea id="update_sla_description" v-model.trim="create_form.description" rows="3" class="form-control modal-form-control text-xs" placeholder="Review supplier documents within 48 hours"></textarea>
              </div>
              <div class="col-12 col-md-4">
                <label class="modal-form-label text-xs" for="update_sla_warning_threshold">Warning Threshold</label>
                <input id="update_sla_warning_threshold" v-model.trim="create_form.warning_threshold" type="text" class="form-control modal-form-control text-xs" placeholder="1 day 12 hours" />
              </div>
              <div class="col-12 col-md-4">
                <label class="modal-form-label text-xs" for="update_sla_escalation_duration">Escalation Duration</label>
                <input id="update_sla_escalation_duration" v-model.trim="create_form.escalation_duration" type="text" class="form-control modal-form-control text-xs" placeholder="3 days" />
              </div>
              <div class="col-12 col-md-4 d-flex align-items-end">
                <label class="modal-form-label text-xs w-100 mb-0">
                  <span class="d-block mb-2">Active</span>
                  <span class="d-flex align-items-center justify-content-between rounded-3 border bg-light px-3 py-2">
                    <span class="text-secondary text-xs">Enable this SLA</span>
                    <input v-model="create_form.is_active" class="form-check-input pm-purple-check ms-2" type="checkbox">
                  </span>
                </label>
              </div>
            </div>

            <div class="mt-3 text-secondary text-xxs">You can type durations like `2 days`, `1 day 12 hours`, or `48 hours`. The app will convert them for the backend.</div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end gap-2">
            <button type="submit"  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1" :disabled="saving">
              <span v-if="saving" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ saving ? 'Updating...' : 'Update SLA' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>
